export const countMultibyteChars = (string: string): number => {
  return Array.from(string).length
}
